import type { Bot } from '@/types/domain'

/** An explicit selection never inherits the caller's fallback. */
export function resolveBot(bots: Bot[], selectedId: number | string | null | undefined, fallback: Bot | null = null): Bot | null {
  if (selectedId == null) return fallback
  return bots.find(bot => String(bot.id) === String(selectedId)) ?? null
}
